import type { ProfileItem } from "../../store/useAuthStore";

export function pickDefaultProfile(
  profiles: ProfileItem[],
): ProfileItem | undefined {
  if (profiles.length === 0) return undefined;
  return (
    profiles.find((p) => p.is_default_profile) ??
    profiles.find((p) => p.vertical_id === 1) ??
    profiles[0]
  );
}

/** Default profile first — matches OTP login normalization. */
export function normalizeProfilesOrder(profiles: ProfileItem[]): ProfileItem[] {
  const defaultProfile = pickDefaultProfile(profiles);
  if (!defaultProfile) return profiles;
  return [defaultProfile, ...profiles.filter((p) => p !== defaultProfile)];
}
